module.exports = __webpack_public_path__ + "img/upload-photo-profile.dea1e5e2.svg";